import MuiButton from '@mui/material/Button';

export const Button = ({ variant = 'primary', color, children, sx = {}, ...rest }) => {
  const muiVariant = variant === 'primary' ? 'contained' : variant === 'secondary' ? 'outlined' : 'text';

  const disabledSx = rest.disabled
    ? {
        '&.Mui-disabled': {
          cursor: 'not-allowed',
          pointerEvents: 'auto',
          borderColor: '#0000001f',
        },
      }
    : {};

  return (
    <MuiButton variant={muiVariant} color={color ?? variant} sx={{ ...sx, ...disabledSx }} {...rest}>
      {children}
    </MuiButton>
  );
};
